const coreId = {
	menu: {
		dashboard: "Dashboard",
		toko: "Toko",
		karyawan: "Karyawan",
		kategori: "Kategori",
		produk: "Produk",
		inventory: {
			title: "Inventory",
			kartu_stok: "Kartu Stok",
			stok_masuk: "Stok Masuk",
			stok_keluar: "Stok Keluar",
			stok_transfer: "Stok Transfer",
			penyesuaian_stok: "Penyesuaian Stok",
		},
		pelanggan: "Pelanggan",
		sistem_point: "Sistem Point",
		kartu: "Kartu",
		promo: "Promo",
		cazhbox: "Cazhbox",
		laporan_offline: "Laporan Toko Offline",
		laporan_online: "Laporan Toko online",
		supplier: "Supplier",
		akun: "Akun",
		profil: "Profil",
	},

	dashboard: {
		title: "Dashboard",
		description: "Statistik Total & Qty Penjualan",
		sales_stats: {
			total: "Statistik Total Penjualan",
			qty: "Statistik Qty Penjualan",
			day: "Hari",
			filter: {
				store: "Semua Toko",
				employee: "Semua Karyawan",
				date: "Periode",
			},
		},
	},

	toko: {
		title: "Dashboard Toko",
		description: "Ringkasan Data dan Informasi Toko",
		stats: {
			title: {
				products: "Produk",
				orders: "Pesanan",
				customers: "Pelanggan",
				revenue: "Pendapatan",
			},
			description: {
				products: "Jumlah produk tersedia",
				orders: "Total pesanan bulan ini",
				customers: "Jumlah pelanggan",
				revenue: "Total pendapatan",
			},
		},
		recent_orders: {
			title: "Pesanan Terbaru",
			description: "{count} pesanan bulan ini",
			view_all: "Lihat Semua",
		},
		sales_chart: {
			title: "Grafik Penjualan",
			description: "Total penjualan {period} dari {from} hingga {to}",
			filterPeriod: {
				weekly: "Mingguan",
				monthly: "Bulanan",
				yearly: "Tahunan",
			},
		},
	},

	authentication: {
		check_card: "Cek Kartu",
		login: {
			title: "Masuk ke akun anda !",
			description:
				"Masukkan alamat email dan password Anda untuk masuk ke sistem.",
			google_signin: "Masuk dengan Google",
		},
		forgot_password: {
			title: "Lupa Password?",
			description: "Masukkan email Anda untuk mengatur ulang password Anda.",
			send_password: "Kirim Password Baru",
			success_title: "Periksa email Anda",
			success_description: "Password baru sudah dikirim ke email kamu.",
		},
	},

	table: {
		select_all: "Pilih semua",
		selected: "Terpilih",
		filter: "Filter",
		rows_per_page: "Baris Per Halaman",
	},

	forms: {
		color: {
			label: "Warna",
			placeholder: "Pilih Warna",
			error_message: "Warna wajib diisi",
		},
		icon: {
			placeholder: "Pilih Icon",
			error_message: "Icon wajib diisi",
		},
		email: {
			label: "Email",
			placeholder: "Masukkan email",
			error_message: "Email wajib diisi",
			invalid_message: "Format email tidak valid",
		},
		password: {
			label: "Password",
			placeholder: "Masukkan password",
			error_message: "Password wajib diisi",
		},
		school_year: {
			error_message: "Tahun ajaran wajib diisi",
		},
		semester: {
			error_message: "Semester wajib diisi",
		},
		start_date: {
			error_message: "Tanggal mulai wajib diisi",
		},
		end_date: {
			error_message: "Tanggal akhir wajib diisi",
		},
		office: {
			error_message: "Instansi wajib diisi",
		},
		school_level: {
			error_message: "Tingkat sekolah wajib diisi",
		},
		school_class: {
			error_message: "Kelas wajib diisi",
		},
		major: {
			error_message: "Jurusan wajib diisi",
		},
		subject: {
			error_message: "Mata pelajaran wajib diisi",
		},
		tag: {
			error_message: "Tag wajib diisi",
		},
		code_tag: {
			error_message: "Kode tag wajib diisi",
		},
		room: {
			error_message: "Ruangan wajib diisi",
		},
		category_event: {
			error_message: "Kategori acara wajib diisi",
		},
		combined_schedule: {
			error_message: "Jadwal gabungan wajib diisi",
		},
		file: {
			error_message: "File wajib diisi",
		},
		start_day: {
			error_message: "Hari mulai wajib diisi",
		},
		weekend_name: {
			error_message: "Nama akhir pekan wajib diisi",
		},
	},

	general: {
		select_file: "Pilih File",
		for_upload: "untuk diupload",
		template_upload_description: "Unduh template untuk upload data",
		login: "Masuk",
		back: "Kembali",
		or: "Atau",
		profile: "Profil",
		language: "Bahasa",
		dark_mode: "Mode Gelap",
		light_mode: "Mode Terang",
		logout: "Keluar",
	},

	settings: {
		institution: {
			detail: {
				form: {
					education_level: {
						error_message: "Tingkat pendidikan wajib diisi",
					},
					pic_phone: {
						error_message: "Nomor telepon PIC wajib diisi",
					},
					institution_address: {
						error_message: "Alamat institusi wajib diisi",
					},
					pic_name: {
						error_message: "Nama PIC wajib diisi",
					},
				},
			},
		},
	},
};

export default coreId;
